import React, { useEffect, useState } from "reactn";
import { Table, Space, Button, Input } from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { EditOutlined, Loading3QuartersOutlined, CheckOutlined, CloseOutlined, ConsoleSqlOutlined } from "@ant-design/icons";

const Results = (props) => {
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);

    let handleTableChange = async () => {
        get();
    }

    let get = async () => {
        const streamRef = collection(firebaseDb, 'stream');
        const streamQuery = query(streamRef, orderBy("active", "desc"), orderBy("order", "asc"));
        const streamSnapshot = await getDocs(streamQuery);
        const streamList = streamSnapshot.docs.map((doc) => {
           
            return {
                id: doc.id,
                
                ...doc.data(),
                active: (doc.data().active ? <CheckOutlined /> : <CloseOutlined />),
                isCodeRequired: (doc.data().isCodeRequired ? <CheckOutlined /> : <CloseOutlined />),
            }
        });

        let streamL = streamList.filter(x => x.questionSetId != undefined )
        setLoading(false)
        setTotalCount(streamL.length);
        setData(streamL);
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    let columns = [
        {
            title: 'Fotograf',
            dataIndex: 'media',
            key: 'media',
            width: 150,
            render: (media, record) => {
                return (
                    <div style={{ width: '200px' }}>
                        <img src={media ? media.url : ""} style={{ width: '100%' }} />
                    </div>
                )
            }
        },
        {
            title: 'Yayın Dili',
            dataIndex: 'lang',
            key: 'lang',
            width: 150,

        },
        {
            title: 'Yayın Adı',
            dataIndex: 'name',
            key: 'name',
            width: 150,

        },
        {
            title: 'Aktif',
            dataIndex: 'active',
            key: 'active',
            width: 50,
        },
        {
            title: 'Sıra',
            dataIndex: 'order',
            key: 'order',
            width: 50,
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 150,
            render: (text, record) => (
                <Space size="small">
                    <Link to={"/results/" + record.id}>
                        <Button className="button-consultant" icon={<EditOutlined />}>Sonuçlar</Button>
                    </Link>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Sonuçlar"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/streams/add">
                        {/* <Button type="light" className="button4" icon={<PlusOutlined />} size="large">Yayın Ekle</Button> */}
                    </Link>
                </div>            </div>
            <div className="table-wrap">
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
            </div>
        </div>
    );
};

export default Results;
